export interface Character {
  id: string;
  name: string;
  role: string;
  age: string;
  motto: string;
  tags: string[];
  intro: string;
  image: string;
}

export const characters: Character[] = [
  {
    id: "ahao",
    name: "阿浩",
    role: "主角 · 电台编辑",
    age: "25 岁",
    motto: "把平凡的日子，过成值得记录的声音。",
    tags: ["社畜日常", "温柔慢热", "成长型男主"],
    intro: "在深夜电台做节目编辑的普通青年，看似佛系，实则把生活里每一个细小瞬间都记得清清楚楚。他是整个故事的观察者与讲述者，所有线索都由他的视角慢慢铺开。",
    image: "https://readdy.ai/api/search-image?query=Stylized%20editorial%20manga%20portrait%20of%20a%20calm%20young%20man%20in%20his%20mid-twenties%20wearing%20a%20casual%20mustard%20jacket%2C%20warm%20vermilion%20and%20cream%20ink%20palette%20with%20halftone%20dots%20and%20soft%20brush%20texture%2C%20vintage%20comic%20illustration%2C%20friendly%20gentle%20expression%2C%20cozy%20slice-of-life%20mood%2C%20clean%20paper%20background%2C%20high%20detail&width=600&height=800&seq=char-ahao&orientation=portrait",
  },
  {
    id: "xiaoyu",
    name: "小雨",
    role: "女主 · 青梅竹马",
    age: "25 岁",
    motto: "有些约定，不管绕多远都会兑现。",
    tags: ["青梅竹马", "阳光元气", "十年之约"],
    intro: "阿浩从小一起长大的发小，性格开朗直率，是两人“十年之约”的另一端。她像一束暖光，总能在阿浩最低落的时候把他拉回正轨，也是结局伏笔里最重要的一环。",
    image: "https://readdy.ai/api/search-image?query=Stylized%20editorial%20manga%20portrait%20of%20a%20cheerful%20young%20woman%20with%20short%20dark%20hair%20and%20warm%20smile%20wearing%20a%20cream%20sweater%2C%20warm%20vermilion%20and%20amber%20ink%20palette%20with%20halftone%20dots%2C%20vintage%20comic%20illustration%2C%20lively%20energetic%20mood%2C%20clean%20paper%20background%2C%20high%20detail&width=600&height=800&seq=char-xiaoyu&orientation=portrait",
  },
  {
    id: "laozhou",
    name: "老周",
    role: "导师 · 电台台长",
    age: "52 岁",
    motto: "声音能传到的地方，故事就不会断。",
    tags: ["资深导师", "金句担当", "幕后推手"],
    intro: "电台的老台长，看起来随性懒散，却是全剧的“点题人”。他那些看似随口的台词，往往藏着对阿浩成长最重要的提醒，结局的落点也与他的一席话遥相呼应。",
    image: "https://readdy.ai/api/search-image?query=Stylized%20editorial%20manga%20portrait%20of%20a%20wise%20middle-aged%20man%20with%20gray%20stubble%20wearing%20a%20vintage%20jacket%20and%20round%20glasses%2C%20warm%20vermilion%20and%20ink%20palette%20with%20halftone%20dots%2C%20vintage%20comic%20illustration%2C%20kind%20observant%20expression%2C%20cozy%20studio%20mood%2C%20clean%20paper%20background%2C%20high%20detail&width=600&height=800&seq=char-laozhou&orientation=portrait",
  },
  {
    id: "hexiu",
    name: "嘿咻",
    role: "吉祥物 · 橘猫",
    age: "4 岁（猫龄）",
    motto: "呼噜呼噜，就是最好的回应。",
    tags: ["镇店之宝", "治愈担当", "隐藏设定"],
    intro: "电台角落里的一只橘猫，是整个故事的“情绪锚点”。它从不说话，却总在最合适的时刻出现。不少读者认为它是全剧真正的灵魂，有关它的隐藏设定也引发了大量讨论。",
    image: "https://readdy.ai/api/search-image?query=Stylized%20editorial%20manga%20illustration%20of%20a%20chubby%20orange%20tabby%20cat%20lounging%20on%20a%20studio%20desk%2C%20warm%20vermilion%20and%20cream%20ink%20palette%20with%20halftone%20dots%20and%20soft%20brush%20texture%2C%20vintage%20comic%20style%2C%20cozy%20and%20calming%20mood%2C%20clean%20warm%20paper%20background%2C%20high%20detail&width=600&height=800&seq=char-hexiu&orientation=portrait",
  },
  {
    id: "xiaolin",
    name: "小林",
    role: "同事 · 节目主播",
    age: "27 岁",
    motto: "热闹是我的底色，认真是我的习惯。",
    tags: ["气氛担当", "嘴硬心软", "隐藏支线"],
    intro: "电台里最活跃的主播，表面嘻嘻哈哈，背地里却藏着自己的成长烦恼。他承包了大量笑点，同时也承担了“普通人的选择”这条隐藏支线。",
    image: "https://readdy.ai/api/search-image?query=Stylized%20editorial%20manga%20portrait%20of%20an%20energetic%20young%20man%20with%20messy%20hair%20and%20bright%20eyes%20wearing%20a%20casual%20plaid%20shirt%2C%20warm%20vermilion%20and%20amber%20ink%20palette%20with%20halftone%20dots%2C%20vintage%20comic%20illustration%2C%20playful%20confident%20mood%2C%20clean%20paper%20background%2C%20high%20detail&width=600&height=800&seq=char-xiaolin&orientation=portrait",
  },
  {
    id: "aling",
    name: "阿玲",
    role: "同事 · 新邻居",
    age: "26 岁",
    motto: "一个人也能把生活过得热气腾腾。",
    tags: ["独居生活", "反差萌", "成长线"],
    intro: "搬到阿浩楼下新来的邻居，独自生活的她在勇敢与脆弱之间来回切换。她的出现推动阿浩重新审视“陪伴”与“独处”的意义，也是中段剧情的重要转折。",
    image: "https://readdy.ai/api/search-image?query=Stylized%20editorial%20manga%20portrait%20of%20a%20composed%20young%20woman%20with%20long%20hair%20wearing%20a%20beige%20knit%20cardigan%2C%20warm%20vermilion%20and%20cream%20ink%20palette%20with%20halftone%20dots%2C%20vintage%20comic%20illustration%2C%20calm%20resilient%20mood%2C%20cozy%20apartment%20setting%2C%20clean%20paper%20background%2C%20high%20detail&width=600&height=800&seq=char-aling&orientation=portrait",
  },
];